import type React from 'react'
import * as Comp from './modal-header.styles'

export function ModalHeader({ children }: { children?: React.ReactNode }) {
  return <Comp.Container>{children}</Comp.Container>
}
